import { useEffect } from "react"
import { matchPath, useLocation } from "react-router"

import { getAppConfig } from '@app/config/getAppConfig'

import { applyPageMeta } from "./applyPageMeta"
import { routeMetaRules } from "./routeMetaRules"

import type { MetaResult } from "./types"


function normalizePathname(pathname: string): string {
    if (pathname === "/") return pathname
    return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname
}

export function RouteMetaManager(): null {
    const location = useLocation()

    useEffect(() => {
        const tenant = getAppConfig()
        const pathname = normalizePathname(location.pathname)

        const defaultTitle = tenant.head?.title
        const defaultDescription = tenant.head?.description

        let meta: MetaResult = {
            title: defaultTitle,
            description: defaultDescription,
        }

        for (const rule of routeMetaRules) {
            const match = matchPath(
                { path: rule.path, end: rule.end ?? true },
                pathname,
            )

            if (!match) continue

            meta = rule.resolve({
                tenant,
                pathname,
                params: match.params,
            })
            break
        }

        applyPageMeta({
            title: meta.title || defaultTitle,
            description: meta.description ?? defaultDescription,
        })
    }, [location.pathname])

    return null
}
